import styled, { css } from 'styled-components'

import { color, font } from '~/styles/utils'

export const CapitalizedSpan = styled.span<{ $expired?: boolean }>`
  ${(props) =>
    props.$expired &&
    css`
      color: #d91208;
    `};

  font-size: 14px;
  line-height: 17px;
  ${font('base')};
  color: ${color('darkGrey')};
  text-transform: uppercase;
`
